export class AiCompositionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getStepAgents(stepId) {
    return this.#http.get(`/api/ai-process-steps/${stepId}/agents`);
  }

  async setStepAgents(stepId, agentIds, acknowledgeCapabilityGaps = false) {
    return this.#http.put(`/api/ai-process-steps/${stepId}/agents`, agentIds, {
      params: { acknowledgeCapabilityGaps },
    });
  }

  async getStepSkills(stepId) {
    return this.#http.get(`/api/ai-process-steps/${stepId}/skills`);
  }

  async setStepSkills(stepId, skillIds, acknowledgeCapabilityGaps = false) {
    return this.#http.put(`/api/ai-process-steps/${stepId}/skills`, skillIds, {
      params: { acknowledgeCapabilityGaps },
    });
  }

  async validateStepComposition(stepId, agentIds, skillIds) {
    return this.#http.post(`/api/ai-process-steps/${stepId}/composition/validate`, {
      agentIds,
      skillIds,
    });
  }

  async getChatConfigurationAgents(chatConfigurationId) {
    return this.#http.get(`/ai-chat-configurations/${chatConfigurationId}/agents`);
  }

  async setChatConfigurationAgents(
    chatConfigurationId,
    agentIds,
    acknowledgeCapabilityGaps = false,
  ) {
    return this.#http.put(`/ai-chat-configurations/${chatConfigurationId}/agents`, agentIds, {
      params: { acknowledgeCapabilityGaps },
    });
  }

  async getChatConfigurationSkills(chatConfigurationId) {
    return this.#http.get(`/ai-chat-configurations/${chatConfigurationId}/skills`);
  }

  async setChatConfigurationSkills(
    chatConfigurationId,
    skillIds,
    acknowledgeCapabilityGaps = false,
  ) {
    return this.#http.put(`/ai-chat-configurations/${chatConfigurationId}/skills`, skillIds, {
      params: { acknowledgeCapabilityGaps },
    });
  }

  async validateChatConfigurationComposition(chatConfigurationId, agentIds, skillIds) {
    return this.#http.post(`/ai-chat-configurations/${chatConfigurationId}/composition/validate`, {
      agentIds,
      skillIds,
    });
  }
}
